<script setup>
import {onMounted, ref, watch} from 'vue';
import {codePreview, formatDate, validatePhoneNumber} from '@/helper';
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue';
import Textarea from '@/components/forms/Textarea.vue';
import Select from '@/components/forms/Select.vue';
import {authData} from '@/services/AuthService';
import Input from '@/components/forms/Input.vue';
import IntermediaryPersonsService from '@/services/IntermediaryPersonsService';
import clientService from '@/services/ClientService';
import {useI18n} from 'vue-i18n';

const props = defineProps({
  clientId: {
    type: String,
    default: null
  }
});

const {t} = useI18n();

const concepts = ref([]);
const isOpen = ref(true);
const emit = defineEmits(['confirm', 'cancel']);
const closeModalWith = (value) => {
  setTimeout(() => {
    if (value === 'confirm') {
      emit('confirm');
      isOpen.value = false;
    } else {
      emit('cancel');
      isOpen.value = false;
    }
  }, 300);
};

onMounted(() => {
  fetchConcepts();
});

function fetchConcepts() {
  clientService.getAllConcepts(props.clientId).then(response => {
    concepts.value = response;
  });
}

function isButtonDisabled() {
  let disabled = true;
  for (const [key, value] of Object.entries(concepts.value)) {
    if (value.length > 0) {
      disabled = false;
    }
  }
  return disabled;
}

function openModal() {
  isOpen.value = true;
}
</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" class="modal show d-block" style="z-index: 1055;">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered modal-lg" style="z-index: 1055">
        <div class="modal-content">
          <DialogPanel class="modal-body p-4 rounded-lg shadow-lg">
            <div class="modal-header">
              <DialogTitle as="h3" class="modal-title">
                {{ t('sendAllConceptsModal.send_all_concepts') }}
              </DialogTitle>
              <i class="btn-close cursor-pointer" @click="closeModalWith('cancel')" aria-label="Close"></i>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12 mb-3">
                  {{ t('clientsDetail.conceptsDescription') }}
                </div>
              </div>
              <div v-for="(forms, name) in concepts">
                <div v-if="forms.length > 0" class="row mb-3">
                  <div class="col-12">
                    <h5 class="mb-1">{{ t('clientsDetail.' + name) }}</h5>
                    <div class="row" v-for="form in forms">
                      <div class="col-6">{{ t('clientsDetail.conceptCreated') }} {{formatDate(form.created_at, 'd.m.Y H:i')}}</div>
                      <div class="col-6">{{ t('clientsDetail.conceptName') }} {{form.name}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-link text-decoration-underline text-dark" @click="closeModalWith('cancel')"> {{ t('sendAllConceptsModal.cancel') }}</button>
              <button :disabled="isButtonDisabled()" class="btn btn-primary btn-md" @click="closeModalWith('confirm')"> {{ t('sendAllConceptsModal.confirm') }}</button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

